import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Translate } from '../../../../shared/LanguageService';
import { IOrder } from './Entities';
import Row from './AdvancedSearchRow';
import moment from 'moment';

interface IAdvanceSearchListProps {
    items: IOrder[];
    user: any;
}

const AdvanceSearchList = (props: IAdvanceSearchListProps) => {
    function displayLegacyOrderNumber(order: IOrder) {
        if (
            order.legacyOrderNumber != null &&
            order.orderCollectionNumber.indexOf(order.legacyOrderNumber) === -1
        ) {
            return <span> ({order.legacyOrderNumber})</span>;
        }
    }

    return (
        <Table className="order-table table-nopadding" hover responsive data-testid="advance-search-table">
            <thead>
                <tr>
                    <th>{Translate('orders/list/advance/header/ordernumber')}</th>
                    <th>{Translate('orders/list/advance/header/broker-firm')}</th>
                    <th>{Translate('orders/list/advance/header/products')}</th>
                    <th>{Translate('orders/list/advance/header/address-to-objekt')}</th>
                    <th>{Translate('orders/list/advance/header/invoice-status')}</th>
                    <th>{Translate('orders/list/advance/header/created')}</th>
                    <th>{Translate('orders/list/advance/header/booked-date')}</th>
                    <th>{Translate('orders/list/advance/header/photo-status')}</th>
                    <th>{Translate('orders/list/advance/header/photographer')}</th>
                </tr>
            </thead>
            <tbody>
                {props.items &&
                    props.items.map((i: IOrder, index: number) => (
                        <tr
                            key={'item-' + index}
                            className={i.isScandphotos ? 'scandphotos' : 'se360'}
                        >
                            <td>
                                <Link to={`/ordercollections/${i.orderCollectionId}`}>
                                    {i.orderCollectionNumber}
                                </Link>
                                :{i.orderNumber}
                                {displayLegacyOrderNumber(i)}
                            </td>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.brokerFirmName}
                            </Row>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.products.length > 1 ? (
                                    <div className="text-truncate-advanced-search">
                                        <div className="advanced-search-textblock">
                                            {i.products[0]}
                                        </div>
                                        <span
                                            className="property-icons align-right"
                                            title={i.products.join('\n').trim()}
                                        >
                                            <i className="material-icons md-18">list</i>
                                        </span>
                                    </div>
                                ) : (
                                    i.products
                                )}
                            </Row>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.address +
                                    (i.address && i.address.length > 0 ? ', ' : '') +
                                    i.city}
                            </Row>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.invoiceStatus ? Translate(i.invoiceStatus) : '-'}
                            </Row>
                            <Row user={props.user} orderId={i.orderId} className="nobreak">
                                {i.created ? moment(i.created).format('L') : ''}
                            </Row>
                            <Row user={props.user} orderId={i.orderId} className="nobreak">
                                {i.orderedDate ? moment(i.orderedDate).format('L') : ''}
                            </Row>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.photoStatus ? Translate(i.photoStatus) : '-'}
                            </Row>
                            <Row user={props.user} orderId={i.orderId}>
                                {i.photographerName}
                            </Row>
                        </tr>
                    ))}
            </tbody>
        </Table>
    );
};

export default AdvanceSearchList;
